import { calcResize } from 'components/Layout/styles';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const SSection = styled.section`
  background: ${props => props.theme.colors.light_grey};
  padding-top: ${calcResize(35, 70)};
  padding-bottom: ${calcResize(35, 70)};
`;

export const SContainer = styled(Container)`
  color: ${props => props.theme.colors.dark_grey};

  h4 {
    font-size: ${calcResize(14, 16)} !important;
    font-weight: normal;
  }
`;
export const STitle = styled.h2`
  font-weight: bold;
  font-size: ${calcResize(35, 45)};
  text-align: center;
`;
export const SDescription = styled.p`
  text-align: center;
  margin: 0 auto;
  font-size: ${calcResize(14, 20)};
  margin: 25px 0 ${calcResize(30, 60)} 0;
`;
